import * as React from "react";
function SvgSwipeLeft(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M11.1 4.6c3.1-.2 6.2.3 9.1 1.4l.4.1c.4 0 .8-.2.9-.6.2-.5-.1-1.1-.6-1.3A25.7 25.7 0 0011 2.6c-2 0-4 .3-6 .6L6.8.3 4 1 1.5 5.1l4.1 2.5 2.8-.7-2.8-1.7c1.8-.4 3.7-.6 5.5-.6zM29.6 18v-.3c-.2-.8-.6-1.5-1.3-1.9s-1.5-.6-2.3-.4l-.9.4a3 3 0 00-3-1.6c-.6.1-1.1.3-1.5.6a3.3 3.3 0 00-2.8-1.1l-1 .3-.7-4v-.3a3 3 0 00-5.4-1.1c-.4.7-.6 1.5-.5 2.2l1.4 9.1a6.9 6.9 0 00-2.4 6.2 7.2 7.2 0 004.6 5.3l.4.1c.4 0 .8-.2.9-.6.2-.5-.1-1.1-.6-1.3a5.3 5.3 0 01-3.3-3.7c-.1-1.2.2-2.4.8-3.3l.5 3.1c.1.5.6.9 1.1.8s.9-.6.8-1.1l-2.2-14.8c-.1-.3 0-.5.1-.8.1-.2.4-.4.6-.4.5-.1 1.1.2 1.2.8l1-.2-1 .4 1.1 6.7v.2l.4 2.2c.1.5.6.9 1.2.8.5-.1.9-.6.8-1.2l-.4-2.4.2-.6c.2-.2.4-.4.7-.4.5-.1.9.2 1.1.6l.2 1.3c.1.5.6.9 1.1.8s.9-.6.9-1.1c-.1-.5.3-1 .9-1.1.5-.1 1 .3 1.1.7l.2 1.7.1.4c.1.5.6.9 1.1.8s.9-.6.8-1.1v-.2l.2-.6c.1-.2.4-.4.6-.4.3-.1.5 0 .8.1.2.1.4.4.4.6L29 28c.1.5.5.9 1 .9h.1c.5-.1.9-.6.8-1.1L29.6 18z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgSwipeLeft);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
